import React, { useEffect } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import { SentenceSmall } from 'src/components/Typography';
import FileInput from '../FileInput';
import { MultiSelectSmall, BackButton, DateInput } from '../../Form';
import Select from 'react-select';

import {
  InputForm,
  Label,
  NextBtn,
  TextareaForm,
  RightInputWrapper,
  TwoInputWrapper,
  InputFormLarge,
  InputsGrid,
} from '../../Form/elements';
import ErrorMessage from '../../Form/ErrorMessage';
import setValueInArray from '../../Form/utils/setValueInArray';
import colors from 'src/style/colors';
import { useRestoreFormManager } from 'src/utils/RestoreForm';
import { selectStyle, selectStyleLarge } from 'src/components/Form/elements';

const FORM_NAME = 'offer-step2';

const languages = [
  'HTML/CSS',
  'JQuery',
  'JavaScript',
  'React',
  'Vue.js',
  'Python',
  'React Native',
  'NodeJS',
  'Ruby (ROR)',
  'PHP',
  'Autre',
];

const SecondBlockSchema = Yup.object().shape({
  contractType: Yup.object().required('Champ obligatoire'),
  jobTitle: Yup.string().required('Champ obligatoire'),
  beginningDate: Yup.string().typeError('Date non valide').required('Champ obligatoire'),
  location: Yup.string().required('Champ obligatoire'),
  experience: Yup.object(),
  salary: Yup.string().required('Champ obligatoire'),
  languages: Yup.array().min(1, 'Sélectionnez au moins un élement'),
  description: Yup.string().required('Champ obligatoire'),
  files: Yup.array(),
});

const SecondBlock = ({ onBackClicked, onSubmit, error, GRCtoken }) => {
  const manager = useRestoreFormManager();
  const initialValues = {
    contractType: '',
    jobTitle: '',
    beginningDate: '',
    location: '',
    experience: '',
    salary: '',
    languages: [],
    description: '',
    files: [],
    ...(manager.get(FORM_NAME) || {}),
  };
  useEffect(() => {
    if (window) {
      window.scrollTo({
        top: 90,
        left: 0,
        behavior: 'smooth',
      });
    } else {
      return null;
    }
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={SecondBlockSchema}
      validateOnMount={true}
      enableReinitialize={false}
      onSubmit={async (values, { setSubmitting }) => {
        onSubmit(values);
        setSubmitting(false);
        // manager.set(FORM_NAME, values);
      }}
    >
      {({ errors, handleChange, setFieldValue, touched, values, isSubmitting }) => {
        const optionsContract = [
          { value: 'CDI', label: 'CDI' },
          { value: 'CDD', label: 'CDD' },
          { value: 'Freelance', label: 'Freelance' },
          { value: 'Stage', label: 'Stage' },
          { value: 'Autres', label: 'Autres' },
        ];

        const optionsExperience = [
          { value: 'Junior', label: 'Junior' },
          {
            value: 'Confirmé',
            label: 'Confirmé',
            isDisabled: values.contractType.value === 'Stage' ? true : false,
          },
          {
            value: 'Senior',
            label: 'Senior',
            isDisabled: values.contractType.value === 'Stage' ? true : false,
          },
          {
            value: 'Peu importe',
            label: 'Peu importe',
            isDisabled: values.contractType.value === 'Stage' ? true : false,
          },
        ];
        const isDisabled = () => {
          try {
            SecondBlockSchema.validateSync(values);
            return false;
          } catch (error) {
            return true;
          }
        };
        return (
          <Form>
            <div
              css={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div>
                <div css={{ display: 'flex', flexDirection: 'row' }}>
                  <Label>Quel type de contrat ?&nbsp;</Label>
                  <SentenceSmall>*</SentenceSmall>
                </div>
                <Select
                  styles={selectStyleLarge}
                  name="contractType"
                  isSearchable={true}
                  placeholder="Sélectionner un contrat..."
                  onChange={(value) => {
                    setFieldValue('contractType', value);
                  }}
                  value={values.contractType}
                  options={optionsContract}
                />

                <ErrorMessage
                  isVisible={errors.contractType && touched.contractType}
                  message={errors.contractType}
                />
              </div>
              <div css={{ paddingTop: 45 }}>
                <div css={{ display: 'flex', flexDirection: 'row' }}>
                  <Label>Quel est l'intitulé du poste ?&nbsp;</Label>
                  <SentenceSmall>*</SentenceSmall>
                </div>
                <InputFormLarge
                  name="jobTitle"
                  errorStyle={errors.jobTitle && touched.jobTitle ? true : false}
                  onChange={handleChange}
                  value={values.jobTitle}
                />
                <ErrorMessage
                  isVisible={errors.jobTitle && touched.jobTitle}
                  message={errors.jobTitle}
                />
              </div>

              <TwoInputWrapper padding>
                <div data-cy="startDate">
                  <div css={{ display: 'flex', flexDirection: 'row' }}>
                    <Label>Date de début :&nbsp;</Label>
                    <SentenceSmall>*</SentenceSmall>
                  </div>
                  <DateInput
                    offerForm={true}
                    value={values.beginningDate}
                    errors={errors.beginningDate && touched.beginningDate}
                    onChange={(date) => {
                      setFieldValue('beginningDate', date);
                    }}
                  />
                  <ErrorMessage
                    isVisible={errors.beginningDate && touched.beginningDate}
                    message={errors.beginningDate}
                  />
                </div>
                <RightInputWrapper>
                  <div css={{ display: 'flex', flexDirection: 'row' }}>
                    <Label>Lieu :&nbsp;</Label>
                    <SentenceSmall>*</SentenceSmall>
                  </div>
                  <InputForm
                    name="location"
                    errorStyle={errors.location && touched.location ? true : false}
                    onChange={handleChange}
                    value={values.location}
                  />
                  <ErrorMessage
                    isVisible={errors.location && touched.location}
                    message={errors.location}
                  />
                </RightInputWrapper>
              </TwoInputWrapper>

              <TwoInputWrapper padding>
                <div>
                  <Label>Expérience : </Label>
                  <Select
                    styles={selectStyle}
                    name="experience"
                    placeholder="Sélectionner..."
                    onChange={(value) => {
                      setFieldValue('experience', value);
                    }}
                    value={values.experience}
                    options={optionsExperience}
                  />

                  <ErrorMessage
                    isVisible={errors.experience && touched.experience}
                    message={errors.experience}
                  />
                </div>
                <RightInputWrapper>
                  <div css={{ display: 'flex', flexDirection: 'row' }}>
                    <Label>Salaire :&nbsp;</Label>
                    <SentenceSmall>*</SentenceSmall>
                  </div>
                  <InputForm
                    name="salary"
                    errorStyle={errors.salary && touched.salary ? true : false}
                    onChange={(e) => {
                      const newValue = e.target.value.replace(/[^0-9]/g, '');
                      setFieldValue('salary', newValue);
                    }}
                    value={values.salary}
                  />

                  <span css={{ marginLeft: -75, color: colors.purpleDark }}>
                    {values.contractType.value === 'Freelance'
                      ? '€ TJM'
                      : values.contractType.value === 'Stage'
                      ? '€ / mois'
                      : 'K€ / an'}
                  </span>

                  <ErrorMessage
                    isVisible={errors.salary && touched.salary}
                    message={errors.salary}
                  />
                </RightInputWrapper>
              </TwoInputWrapper>

              <div css={{ paddingTop: 45 }}>
                <div css={{ display: 'flex', flexDirection: 'row' }}>
                  <Label>Quelles sont les technologies que vous utilisez ?&nbsp;</Label>
                  <SentenceSmall>*</SentenceSmall>
                </div>
                <InputsGrid>
                  {languages.map((item) => (
                    <MultiSelectSmall
                      key={item}
                      isSelected={values.languages.includes(item)}
                      onClick={() => {
                        setFieldValue('languages', setValueInArray(values.languages, item));
                      }}
                    >
                      {item}
                    </MultiSelectSmall>
                  ))}
                </InputsGrid>
                <ErrorMessage
                  isVisible={errors.languages && touched.languages}
                  message={errors.languages}
                />
              </div>

              <div css={{ paddingTop: 45 }}>
                <div css={{ display: 'flex', flexDirection: 'row' }}>
                  <Label>Description :&nbsp;</Label>
                  <SentenceSmall>*</SentenceSmall>
                </div>
                <TextareaForm
                  name="description"
                  errorStyle={errors.description && touched.description ? true : false}
                  onChange={handleChange}
                  value={values.description}
                />
                <ErrorMessage
                  isVisible={errors.description && touched.description}
                  message={errors.description}
                />
              </div>

              <div css={{ paddingTop: 45 }}>
                <Label>Joindre votre/vos offres(s)</Label>
                <FileInput
                  errors={errors && touched}
                  value={values.files}
                  onChange={(list) => {
                    setFieldValue('files', list);
                  }}
                />
              </div>

              <div
                css={{
                  paddingBottom: 15,
                  display: 'flex',
                  alignItems: 'baseline',
                  justifyContent: 'space-between',
                }}
              >
                <BackButton onClick={onBackClicked} />
                <NextBtn type="submit" disabledStyle={isDisabled()} disabled={isSubmitting}>
                  Envoyer
                </NextBtn>
              </div>
              {error && (
                <ErrorMessage
                  css={{ textAlign: 'end' }}
                  isVisible={error}
                  message={
                    GRCtoken
                      ? 'Une erreur est survenue.'
                      : "Une erreur est survenue ! Vérifiez que vous n'êtes pas derrière un VPN. Si le problème persiste, merci de nous contacter directement."
                  }
                />
              )}

              <SentenceSmall>* Champ obligatoire</SentenceSmall>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};
export default SecondBlock;
